<template>
  <form @submit.prevent="submitForm">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6">
        <label for="clientFirstName">Client First Name</label>
        <InputText
          id="clientFirstName"
          type="text"
          v-model="client.firstName"
        />
      </div>

      <div class="p-field p-col-6">
        <label for="clientLastName">Client Last Name</label>
        <InputText id="clientLastName" type="text" v-model="client.lastName" />
      </div>

      <div class="p-field p-col-12">
        <label for="clientJob">Job</label>
        <InputText id="clientJob" type="text" v-model="client.job" />
      </div>

      <div class="p-field p-col-6">
        <label for="clientLandline">Client phone (landline)</label>
        <InputMask
          id="clientLandline"
          v-model="client.landline"
          mask="99-99-99-99-99"
        />
      </div>

      <div class="p-field p-col-6">
        <label for="clientMobile">Client phone (mobile)</label>
        <InputMask
          id="clientMobile"
          v-model="client.mobile"
          mask="99-99-99-99-99"
        />
      </div>

      <div class="p-field p-col-12">
        <label for="clientEmail">E-mail</label>
        <InputText id="clientEmail" type="email" v-model="client.email" />
      </div>

      <div class="p-field p-col-12">
        <label for="clientAddress">Address</label>
        <InputText id="clientAddress" type="text" v-model="client.address" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="clientCity">City</label>
        <InputText id="clientCity" type="text" v-model="client.city" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="clientPostalCode">Postal Code</label>
        <InputNumber
          id="clientPostalCode"
          v-model="client.postalCode"
          mode="decimal"
          :useGrouping="false"
        />
      </div>

      <div class="p-field p-col-12">
        <label for="clientNotes">Notes</label>
        <Textarea
          id="clientNotes"
          v-model="client.notes"
          :autoResize="true"
          rows="2"
          cols="30"
        />
      </div>
    </div>
    <Button label="Save Client" type="submit" class="p-mt-3" />
  </form>
</template>

<script>
import { reactive } from "vue";
export default {
  emits: ["form-submitted"],
  setup(_props, context) {
    const client = reactive({
      firstName: null,
      lastName: null,
      job: null,
      landline: null,
      mobile: null,
      email: null,
      address: null,
      city: null,
      postalCode: null,
      notes: null
    });
    function submitForm() {
      context.emit("form-submitted", client);
    }

    return { client, submitForm };
  }
};
</script>
